import React, { Fragment } from "react";
import styled from "styled-components";
import _ from "lodash";
import num from "numeral";
import { connect } from "formik";
import { Grid } from "@material-ui/core";
import { AutoCompleteInput, TextInput, MoneyInput, CheckboxSelectListInput, IntegerInput, FastFormikCheckbox } from "components/Global/FastFormikMaterial";

import ViewOnlyDiv from "./ViewOnlyDiv";
import LateralField from "./LateralField";

const securitizedInput = ({ label, midLabel, placeholder, formik, isDisabled, hasBorder, isSecuritized, securitizationDate, onChange, shouldHideForQuote, ...otherProps }) => {
  if (shouldHideForQuote) {
    return null;
  }

  const { values } = formik;
  const options = [
    { name: "January", value: "0" },
    { name: "February", value: "1" },
    { name: "March", value: "2" },
    { name: "April", value: "3" },
    { name: "May", value: "4" },
    { name: "June", value: "5" },
    { name: "July", value: "6" },
    { name: "August", value: "7" },
    { name: "September", value: "8" },
    { name: "October", value: "9" },
    { name: "November", value: "10" },
    { name: "December", value: "11" }
  ];
  const dateComponents = securitizationDate ? securitizationDate.split("-") : "";

  return (
    <LateralField label={label} hasBorder={hasBorder}>
      {isDisabled && !isSecuritized && (
        <Grid item xs={3}>
          <span>No</span>
        </Grid>
      )}
      {isDisabled && isSecuritized && (
        <Grid item xs={5}>
          {"Securitized "}
          <FastFormikCheckbox
            label={placeholder}
            checked
            onChange={null}
            value={null}
            disabled
          />
          {dateComponents[1] && <span>
            {options.find(o => o.value == parseInt(dateComponents[1]) - 1).name}
            {" "}
            {dateComponents[0]}
                                </span>}
        </Grid>
      )}
      {!isDisabled && (
        <Grid container item xs={12}>
          <Grid item xs={3}>
            {"Securitized "}
            <FastFormikCheckbox
              label={placeholder}
              fieldName={"prepaymentTerms.isSecuritized"}
              name={"prepaymentTerms.isSecuritized"}
              disabled={isDisabled}
              checked={_.get(formik.values, "prepaymentTerms.isSecuritized")}
              onChange={formik.handleChange}

              {...otherProps}
            />

          </Grid>
          {isSecuritized && <>
            <Grid item xs={3}>
              <AutoCompleteInput
                formik={formik}
                fieldName={"prepaymentTerms.securitizationMonth"}
                selectName="name"
                selectValue="value"
                // onChange = {formik.handleChange}
                options={options}
              />
            </Grid>

            <Grid item xs={1} />
            <Grid item xs={3}>
              <IntegerInput
                fullWidth

                fieldName={"prepaymentTerms.securitizationYear"}
                placeholder={"Year (YYYY)"}
                {...otherProps}
              />
            </Grid>
                            </>}
        </Grid>)}
    </LateralField>
  );
};
export default connect(securitizedInput);
